if (!Librarian.MyFavorite)
    Librarian.MyFavorite = {};

Librarian.MyFavorite.EditWindow = new Class({
    Extends: Librarian.Window,
    Binds: ["editFavorite", "editSuccess"],

    options: {
        id: "editFavoriteWindow",
        width: 360,
        height: 230,
        data: null,
        name: '',
        descr: ''
    },

    onEditComplete: null,
    onDeleteComplete: null,
    deleteWindow: null,
    data: null,
    langPrefix: "favorite",

    initialize: function(options) {
        this.data = options.data;
        options.data = null;

        this.setOptions(options);

        // Use the SlideShow translations for slide shows
        if (this.data.isslideshow)
            this.langPrefix = "slideshow";

        // Set the title on init so that we can use the localization
        this.options.title = Librarian.Lang.getString(this.langPrefix + "_edit");

        // Set the content location
        this.options.contentURL = (Librarian.editFavoriteDialog.fromLibrary ? Librarian.path.getLibraryPath() : Librarian.path.getLayoutsPath()) + Librarian.editFavoriteDialog.pageName;

        // If we are given data
        if (this.data) {
            // And it's not a file, add Category to the title
            if (!this.data.fileid && !this.data.presid)
                this.options.title += ' ' + Librarian.Lang.getString("category");
        }

        this.parent(this.options);
    },

    onWindowLoaded: function() {
        this.parent();

        var itemEl = $("editSubmit");
        // If the remove button is there
        if (itemEl) {
            // Add the onclick method
            itemEl.addOnClick(this.editFavorite);
            // And update the ID
            itemEl.id = this.options.id + '_' + itemEl.id;
        }

        itemEl = $("editCancel");
        if (itemEl) {
            // Add the onclick method
            itemEl.addOnClick(this.close);
            // And update the ID
            itemEl.id = this.options.id + '_' + itemEl.id;
        }

        itemEl = $("editFavName");
        if (itemEl) {
            // Add the given name to the text box
            Librarian.Utils.setElementValue(itemEl, this.options.name);
            // Focus the name box so that it's convenient for the user
            if (itemEl.isVisible())
                itemEl.focus();
        }

        // Add the given description to the text box
        Librarian.Utils.setElementValue($("editFavDescription"), this.options.descr);

        // Resize if using a custom window
        itemEl = this.getElement("favSize");
        if (itemEl) {
            this.options.width = itemEl.width.value.toInt();
            this.options.height = itemEl.height.value.toInt() ;

            // Then resize the window
            this.resize({
                width: this.options.width,
                height: this.options.height,
                centered: false
            });
        }
    },

    onClose: function() {
        if (this.deleteWindow)
            this.deleteWindow.close();

        this.parent();
    },

    editFavorite: function() {
        var itemEl = $("editFavName");
        if (!itemEl)
            return;

        var name = (Librarian.Utils.getElementValue(itemEl) || '').trim();
        if (name.length == 0) {
            Librarian.Utils.error(Librarian.Lang.getString(this.langPrefix + "_namerequired"));
            return;
        }

        var description = (Librarian.Utils.getElementValue($("editFavDescription")) || '').trim(),
            url = Librarian.path.getUpdateUrl((this.data.presid || this.data.fileid) ? "vprn" : "vpcrn") +
                    "&name=" + encodeURIComponent(name) +
                    "&descr=" + encodeURIComponent(description);

        if (this.data.presid || this.data.fileid) {
            url += "&pid=" + (this.data.presid || this.data.fileid);
            if (this.data.prestype)
                url += "&type=" + this.data.prestype;
        }
        else
            url += "&cid=" + this.data.catid;

        new Librarian.Request({
            url: url,
            onSuccess: this.editSuccess,
            onFailure: Librarian.Utils.onFailure
        }).send();
    },

    editSuccess: function() {
        if (typeof this.onEditComplete == "function")
            this.onEditComplete();

        Librarian.Utils.notification(Librarian.Lang.getPluralArgString(this.langPrefix + "_updated", 1, [(this.data.presid || this.data.fileid) ? '' : ' ' + Librarian.Lang.getString("category")]));

        this.close();
    }
});